module.exports = __webpack_public_path__ + "static/media/BB_howtoboost_Mobile_EN.253082eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BB_howtoboost_Mobile_EN.png
// module id = 712
// module chunks = 0